import React from 'react';
import { offerList as api } from '../../api';
import { useRequest } from '../../hooks/requestHook';
import { useTranslation } from 'react-i18next';
import IncrementalSearchSelect from '../molecules/IncrementalSearchSelect';
var OfferSelect = function (_a) {
    var query = _a.query, value = _a.value, onChange = _a.onChange;
    var t = useTranslation().t;
    var getAll = useRequest(api.getOffers);
    var getOptionLabel = React.useCallback(function (_a) {
        var lotNumber = _a.lotNumber, name = _a.offerList.name;
        return "".concat(lotNumber, " (").concat(name, ")");
    }, []);
    return (React.createElement(IncrementalSearchSelect, { label: t('params.offer.lotNumber'), placeholder: "Please input lot number", getOptionLabel: getOptionLabel, api: getAll, query: query, value: value, searchKey: "lot_number_cont", onChange: onChange }));
};
export default OfferSelect;
